interface IHotelChildrenSettingCategoriesComplexChildrenSetting {
  childrenA: string;
  childrenA2: string;
  childrenB: string;
  childrenB2: string;
  childrenC: string;
  childrenD: string;
}

export const HotelChildrenSettingCategoriesComplexChildrenSetting: IHotelChildrenSettingCategoriesComplexChildrenSetting =
  {
    childrenA: "children_a",
    childrenA2: "children_a2",
    childrenB: "children_b",
    childrenB2: "children_b2",
    childrenC: "children_c",
    childrenD: "children_d",
  };

interface IHotelChildrenSettingCategoriesSimpleChildrenSetting {
  children: string;
  infants: string;
}

export const HotelChildrenSettingCategoriesSimpleChildrenSetting: IHotelChildrenSettingCategoriesSimpleChildrenSetting =
  {
    children: "children",
    infants: "infants",
  };

interface IHotelChildrenSettingCategoriesOthers {
  childrenOther1: string;
  childrenOther2: string;
  childrenOther3: string;
}

export const HotelChildrenSettingCategoriesOthers: IHotelChildrenSettingCategoriesOthers =
  {
    childrenOther1: "children_other1",
    childrenOther2: "children_other2",
    childrenOther3: "children_other3",
  };

export const HotelChildrenSettingAllCategories = {
  ...HotelChildrenSettingCategoriesComplexChildrenSetting,
  ...HotelChildrenSettingCategoriesSimpleChildrenSetting,
  ...HotelChildrenSettingCategoriesOthers,
};
